import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../../../core/service/v2/abstractRepositoryV2";
import {TreatmentJourneyModel} from "../../../api/entity/treatmentJourney.model";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyRepository extends AbstractRepositoryV2<TreatmentJourneyModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('TreatmentJourney', serviceElementsFactory, injector);
    }
}
